<template>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="550px"
    >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="labelWidth" prop="logUrl" label-position="left">
            <el-form-item :label="$t('table.appName')" :prop="title == $t('common.lookApp')? '': 'name'">
                <span v-if="title == $t('common.lookApp')">
                  {{ ruleForm.os == 1? 'Andriod' : 'iOS' }}-{{ruleForm.name}}
                </span>
                <div v-else>
                  <span style="display:inline-block;width: 60px;text-align: right;">{{ ruleForm.os == 1? 'Andriod' : 'iOS' }}- </span>
                  <el-input v-model="ruleForm.name" @input="nameInput"  style="width: 278px"></el-input>
                </div>
            </el-form-item>
            <el-form-item :label="$t('table.appPackageName')" :prop="title == $t('common.lookApp')? '': 'package_name'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.package_name}}</span>
                <el-input v-else v-model="ruleForm.package_name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('table.appPlat')" :prop="title == $t('common.lookApp')? '': 'os'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.os == 1? 'Andriod' : 'iOS'}}</span>
                <el-radio-group v-else v-model="ruleForm.os">
                    <el-radio :label="1">Andriod</el-radio>
                    <el-radio :label="2">iOS</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('table.accessMode')" :prop="title == $t('common.lookApp')? '': 'docking_type'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.docking_type == 1? 'SDK' : 'API'}}</span>
                <el-radio-group v-else v-model="ruleForm.docking_type">
                    <el-radio  :label="1">SDK</el-radio>
                    <!-- <el-radio  :label="2">API</el-radio> -->
                </el-radio-group>
            </el-form-item>
            <!-- 应用类目 -->
            <el-form-item :label="$t('table.appCate')" :prop="title == $t('common.lookApp')? '': 'category_data'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.category_name}}</span>
                <el-cascader
                    v-else
                    v-model="ruleForm.category_data"
                    :options="cateOption"
                    :props="{value: 'id', label: 'name'}"
                >
                </el-cascader>
            </el-form-item>
            <el-form-item :label="$t('table.appDaily')" :prop="title == $t('common.lookApp')? '': 'dau'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.dau}}</span>
                <el-input v-else v-model.number="ruleForm.dau"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.appstoreUrl')" :prop="title == $t('common.lookApp')? '': 'appstore_url'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.appstore_url}}</span>
                <el-input v-else v-model="ruleForm.appstore_url" :placeholder="$t('common.appstoreUrl_ph')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.website')" :prop="title == $t('common.lookApp')? '': 'website'">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.website}}</span>
                <el-input v-else v-model="ruleForm.website" :placeholder="$t('common.website_ph')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('table.appType')">
                <span v-if="title == $t('common.lookApp')">{{ruleForm.paid ? $t('common.paid') : $t('common.free')}}</span>
                <el-radio-group v-else v-model="ruleForm.paid">
                    <el-radio :label="true">{{$t('common.paid')}}</el-radio>
                    <el-radio :label="false">{{$t('common.free')}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" v-if="title !== $t('common.lookApp')">
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isDisabled">{{$t('save')}}</el-button>
            <el-button @click="handleClose">{{$t('cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
const defaultRuleForm = {
    name: '',
    package_name: '',
    os: 1,
    category_data: [],
    docking_type: 1,
    dau: "",
    // desc: "",
    appstore_url: "",
    website: "",
    paid: false,
}
export default {
    props:{
        title: {
            type: String,
            default: ""
        },
        visible: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
        },
    },
    data() {
        return {
            ruleForm: Object.assign({}, defaultRuleForm),
            cateOption: [],
            labelWidth: '100px',
            isDisabled: false, // 防止重复点击
            timer: null,
        }
    },
    computed: {
        rules() {
            return {
                name: [
                    { required: true, message: this.$t('required.name'), trigger: 'blur' }
                ],
                package_name: [
                    { required: true, message: this.$t('required.packageName'), trigger: 'blur' }
                ],
                os: [
                    { required: true, message: this.$t('required.os'), trigger: ['change','blur'] }
                ],
                dau: [
                    { required: true, message: this.$t('required.dau'), trigger: 'blur' },
                    { type:'number', message: this.$t('required.number'), trigger: 'blur' }
                ],
                // desc: [
                //     { required: true, message: this.$t('required.desc'), trigger: 'blur' }
                // ],
                category_data: [
                    { required: true, message: this.$t('required.cate'), trigger: 'blur' }
                ],
                appstore_url: [
                    { required: true, message: this.$t('common.enter') + this.$t('common.appstoreUrl'), trigger: 'blur' }
                ],
                website: [
                    { required: true, message: this.$t('common.enter') + this.$t('common.website'), trigger: 'blur' }
                ]
            }
        }
    },
    created(){
        if(this.visible) {
            if(this.title == this.$t('common.addApp')) {
                this.ruleForm = Object.assign({}, defaultRuleForm)
            }
            if(this.title == this.$t('common.editApp') || this.title == this.$t('common.lookApp')) {
                this.ruleForm = Object.assign({}, this.rowData)
                // 编辑的时候应用名称把前缀去掉
                if (/Andriod\-|ios\-/.test(this.ruleForm.name)) {
                  this.ruleForm.name = this.ruleForm.name.split("-")[1]
                }
                if(this.rowData.parent_cid !== 0 && this.rowData.cid !== 0) {
                    let arr = [this.rowData.parent_cid, this.rowData.cid]
                    this.ruleForm.category_data = arr
                }
            }
        }

        var lang = localStorage.getItem("lang")
        if(lang == 'en') {
            this.labelWidth = '150px'
        } else if (lang == 'zh') {
            this.labelWidth = '100px'
        }
        this.getAppCategory()
    },
    beforeDestroy() {
        if(this.timer) {
        clearTimeout(this.timer)
        this.timer = null
        }
    },
    methods: {
        nameInput(val){
            console.log(val)
        },
        submitForm(formName) {
            this.isDisabled = true
            this.timer = setTimeout(() => { 
                this.isDisabled = false
                clearTimeout(this.timer)
            }, 1500);
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$message.error(this.$t('message.errorComplete'));
                    this.isDisabled = false;
                    clearTimeout(this.timer);
                    this.timer = null;
                    return false;
                }
                let params = JSON.parse(JSON.stringify(this.ruleForm))
                params.name = this.ruleForm.os == 1? 'Andriod-'+ params.name : 'iOS-'+ params.name
                this.__postData('sspAppAdd', params, res => {
                    clearTimeout(this.timer)
                    this.timer = null
                    if(res.code == 1) {
                        this.$message.error(res.msg);
                    } else {
                        this.$parent.dialogVisible = false
                        this.$message.success(this.$t('message.successSava'));
                        this.$parent.getData()
                    }
                    this.isDisabled = false
                }, errmsg => {
                    this.isDisabled = false;
                    clearTimeout(this.timer);   
                    this.timer = null;
                    this.$message.error(errmsg);
                });
            });
        },
        getAppCategory() {
            this.__getData('getAppCategory', null, res => {
                this.cateOption = res.list
            }, errmsg => {
            });
        },
        // 关闭弹窗
        handleClose() {
            this.$parent.dialogVisible = false
        },
        // osChange(val) {
        //     // 应用平台选择IOS 时，接入方式SDK 不可选（目前暂不支持IOS 的SDK对接形式）
        //     if(val == 2) {
        //         this.ruleForm.docking_type = 2
        //     }
        // }
    },

}
</script>

<style>
    /* .container {
        min-height: 500px;
    } */
    .el-cascader {
        width: 100%;
    }
</style>
